'use strict';

module.exports = {
    unspecified: 'unspecified',
    cover: 'cover',
    inside: 'inside',
    backCover: 'back cover',
};
